export const INACTIVATE_COMPANY_CONFIRM_TEXT = "Inativar gestora";

export const INACTIVATE_COMPANY_WARNING = "Ela não será completamente deletada, e segue acessível pelo filtro de status inativo.";

export const buildInactivateCompanyDescription = (companyName?: string) =>
  `A gestora ${companyName ?? ""} será inativada e seus usuários perderão o acesso à plataforma.`;
